import api from '@/api';
import { notification } from 'antd';

const initialState = {
	showUserDataDialog: false,
	loading: false,
	loaded:  false,
	userData: null,
};

export const types = {
	SET_STATE: 'USERDETAIL/SET_STATE',
};

const reducers = (state = initialState, action) => {
	switch(action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };
		default:
			return state;
	}
};

export default reducers;

export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),
	resetUserModal: () => ({
		type: types.SET_STATE, data: {
			showUserDataDialog: false,
		},
	}),
	reset: () => ({ type: types.SET_STATE, data: { ...initialState } }),


	resetUserPassword: (email, password) => async (dispatch, getState) => {
		dispatch({ type: types.SET_STATE, data: { loading: true } });

		try {
			let res = await api.post('/account/reset_token', {email});
			await api.post('/account/reset', {email, password, resetToken: res.Code});
			dispatch({
				type: types.SET_STATE,
				data: {
					...initialState,
					loaded:       true,
					loading: false,
				},
			});
			notification['success']({
				duration: 1,
			    message: 'Update Success!',
			    description:
			      'Changed password successfully',
			});
		} catch(err) {
			notification['error']({
				duration: 1,
			    message: 'Update failure!',
			    description:
			      'Invalid Credential',
			});
			dispatch({
				type: types.SET_STATE,
				data: { loaded: false, loading: false },
			});
		}
	},
};
